/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const DistributedRewardSubject = {
    OVERWOLF_REWARD: 'OVERWOLF_REWARD',
    QUEST_PROGRESS_AUTO_REWARD: 'QUEST_PROGRESS_AUTO_REWARD',
    MANUAL_DISTRIBUTION: 'MANUAL_DISTRIBUTION',
    SPONSORED_COMPETITION_REWARD: 'SPONSORED_COMPETITION_REWARD',
    LOOTBOX_REWARD: 'LOOTBOX_REWARD',
    OVERWOLF_TIME_REWARD: 'OVERWOLF_TIME_REWARD',
    CHALLENGE_REWARD: 'CHALLENGE_REWARD',
    PRIZE_POOL: 'PRIZE_POOL',
    FUELUP_ADVENTURE: 'FUELUP_ADVENTURE',
    FUELUP_FUEL_STATION_BONUS: 'FUELUP_FUEL_STATION_BONUS',
    FUELUP_SPIN_WHEEL: 'FUELUP_SPIN_WHEEL',
    FUELUP_VAULT_DAILY: 'FUELUP_VAULT_DAILY',
    FUELUP_VAULT_WEEKLY: 'FUELUP_VAULT_WEEKLY',
    FUELUP_VAULT_MONTHLY: 'FUELUP_VAULT_MONTHLY',
    PLAYABLE_AD_REWARD: 'PLAYABLE_AD_REWARD',
    LEVEL_UP_REWARD: 'LEVEL_UP_REWARD',
    GAMIFICATION_REWARD: 'GAMIFICATION_REWARD',
    PROMO_TOKEN_REDEEMED: 'PROMO_TOKEN_REDEEMED',
    REFERRAL_REWARD: 'REFERRAL_REWARD'
} as const;
export type DistributedRewardSubject = typeof DistributedRewardSubject[keyof typeof DistributedRewardSubject];


export function instanceOfDistributedRewardSubject(value: any): boolean {
    for (const key in DistributedRewardSubject) {
        if (Object.prototype.hasOwnProperty.call(DistributedRewardSubject, key)) {
            if (DistributedRewardSubject[key as keyof typeof DistributedRewardSubject] === value) {
                return true;
            }
        }
    }
    return false;
}

export function DistributedRewardSubjectFromJSON(json: any): DistributedRewardSubject {
    return DistributedRewardSubjectFromJSONTyped(json, false);
}

export function DistributedRewardSubjectFromJSONTyped(json: any, ignoreDiscriminator: boolean): DistributedRewardSubject {
    return json as DistributedRewardSubject;
}

export function DistributedRewardSubjectToJSON(value?: DistributedRewardSubject | null): any {
    return value as any;
}

export function DistributedRewardSubjectToJSONTyped(value: any, ignoreDiscriminator: boolean): DistributedRewardSubject {
    return value as DistributedRewardSubject;
}

